export default "__VITE_ASSET__CWc9hmuS__"